import React, { useEffect, useRef, useState } from 'react';
import { isEmpty, values } from 'lodash';
import {
  NavLink,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import { useTranslation } from 'react-i18next';
import closeIcon from '../../../assets/icons/close-icon-contained.svg';
import ThreeDotsIcon from '../../../assets/icons/three-dots.svg';
import leftArrow from '../../../assets/icons/left-arrow.svg';

import {
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from '@material-tailwind/react';
import { Dialog, DialogBody } from '@material-tailwind/react';
import BadgeCard from '../../badge/Badge';
import { HeaderItemsModel } from '../../companyMenu/sidebarItemsModel';
import { LARGE_BREAK_POINT } from '../../../constants';
import { AppLoader } from '../../appLoader/AppLoader';

interface Iprops {
  middleContent?: JSX.Element | null;
  middleContentClass?: string | null;
  topContent?: JSX.Element | null;
  element?: JSX.Element | null;
  placeHolder?: JSX.Element | null;
  title?: JSX.Element | null | string;
  description?: JSX.Element | null | string;
  subDescription?: JSX.Element | null | string;
  handle?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  removebg?: boolean;
  showCloseButton?: boolean;
  infoStatus?: JSX.Element | null;
  loaderText?: string | null;
  isCreating?: boolean;
  closeModal?: () => void;
  dropDownMenuContent?: JSX.Element | null;
  outerBadgeCss?: string | null;
  badgeInfo?:
    | {
        label?: string | null;
        upperLabel?: string | JSX.Element | null;
        colorClass?: string;
      }
    | JSX.Element
    | null;
  isLoadingData?: boolean;
  setShowBackButton: React.Dispatch<React.SetStateAction<boolean>>;
  showBackButton: boolean;
  currentTabRoutes: Array<HeaderItemsModel>;
  backRoute: any;
}

const ModalLayoutComponent = ({
  badgeInfo = null,
  infoStatus,
  outerBadgeCss = '',
  title,
  middleContentClass,
  showCloseButton,
  handle,
  disabled,
  middleContent,
  topContent,
  element,
  placeHolder,
  description,
  subDescription,
  dropDownMenuContent,
  isLoadingData,
  closeModal,
  loaderText,
  removebg,
  isCreating,
  setShowBackButton,
  showBackButton,
  currentTabRoutes,
  backRoute,
}: Iprops): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [hasQueryRoute, setHasQueryRoute] = useState(false);
  const [hasQueries, setHasQueries] = useState(false);
  const routeParams = useParams();

  const [searchParams] = useSearchParams();
  const searchAsObject = Object.fromEntries(new URLSearchParams(searchParams));
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const closeMenu = () => setIsMenuOpen(false);
  const panelRef = useRef(null);

  useEffect(() => {
    setHasQueryRoute(() => !values(searchAsObject).every(isEmpty));
    setHasQueries(() => !values(searchAsObject).every(isEmpty));
  }, [searchAsObject, routeParams]);

  useEffect(() => {
    setShowBackButton(true);
    return () => setShowBackButton(false);
  }, []);

  const rightPanel = (
    <div
      className={`${(element || placeHolder) && 'lg:!flex px-4'}
      ${!element && 'hidden '}
      ${!(element || placeHolder) && 'hidden'} ${isLoadingData && 'h-screen'}
      ${!hasQueryRoute && !!dropDownMenuContent && 'hidden lg:flex'}
      flex-col relative overflow-hidden flex h-full z-[1] col-span-5 sm:px-6 sm:pt-4 pb-0 sm:my-6 lg:rounded-[20px] bg-white
      sm:max-h-[calc(100vh-90px)] max-h-[calc(100vh-30px)]
      `}
    >
      {isLoadingData && (
        <div className="h-full flex justify-center items-center ">
          <AppLoader />
        </div>
      )}
      <div
        className={`${
          isLoadingData && 'blur-[4px]  pointer-events-none '
        } overflow-hidden h-full  `}
      >
        {description && (
          <button
            onClick={closeModal}
            type="button"
            className="p-1 mt-1 bg-transparent  flex-row outline-none absolute top-0 left-8 hidden   "
          >
            <img className="" src={leftArrow} alt="back" />
            <span className="text-blue-00 text-base ml-2 ">
              {' '}
              {t('buttons.back')}
            </span>
          </button>
        )}

        <div
          className={`${
            hasQueryRoute && !!element && 'min-h-[50px]'
          } sm:flex block  sticky  top-0  pl-[4px]  z-10  justify-between items-center `}
        >
          {hasQueryRoute && !!element ? (
            <button
              onClick={closeModal}
              type="button"
              className="p-1 mt-1 bg-transparent  flex-row outline-none    flex sm:hidden  "
            >
              <img className="" src={leftArrow} alt="back" />
              <span className="text-blue-00 text-base ml-2 ">
                {' '}
                {t('buttons.back')}
              </span>
            </button>
          ) : null}
          <div className="flex flex-row ">
            {description && (
              <div>
                <h5 className="font-bold text-2xl  text-neutral-12 text-left mb-3">
                  {description}
                </h5>
                <h5 className="font-semibold text-base  text-neutral-40/20 ">
                  {subDescription}
                </h5>
              </div>
            )}
            {hasQueryRoute && !!element ? (
              <button
                onClick={closeModal}
                type="button"
                className="absolute right-0 top-2 border-none outline-none shadow-none bg-transparent sm:block hidden "
              >
                <img className=" " src={closeIcon} alt="close" />
              </button>
            ) : null}
          </div>
        </div>
        {infoStatus ? (
          <div className={` ${infoStatus && 'h-full'}  mb-3`}>{infoStatus}</div>
        ) : (
          <></>
        )}
        <div
          className={`mt-0 h-full  pt-4 pb-[30px] sm:pb-4 lg:pb-8  sm:max-h-[calc(100vh-90px)] max-h-[calc(100vh-30px)] overflow-y-auto overflow-x-hidden ${
            element && ''
          }`}
        >
          <CSSTransition
            in={!!element}
            timeout={500}
            unmountOnExit
            classNames="transition"
          >
            {element || <></>}
          </CSSTransition>

          {placeHolder !== null ? (
            <div className="hidden lg:grid  relative min-h-[200px] h-full pb-4 ">
              {placeHolder}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );

  const content = (
    <div
      ref={panelRef}
      className={` ${
        (element || placeHolder) &&
        '!top-0 h-full lg:grid lg:grid-cols-12 w-screen lg:mx-10 '
      } ${!(element || placeHolder) && 'mx-auto my-0 '}
      ${!(element || placeHolder) && !removebg && ' bg-white '}
      ${middleContentClass && middleContentClass}`}
    >
      <div
        className={` md:mt-4  h-full relative lg:col-span-7  mb-4 ${
          !(element || placeHolder) && ''
        }   `}
      >
        <div
          className={`${
            hasQueryRoute && !!element && 'hidden  sm:block '
          } h-full `}
        >
          <div className="relative h-full overflow-x-hidden overflow-y-auto  px-6 pt-0 pb-1.5 max-h-[calc(100vh-60px)]">
            <div className={'mt-3 mb-1'}>
              {showBackButton && (
                <button
                  onClick={() => {
                    if (backRoute)
                      navigate(
                        typeof backRoute === 'string'
                          ? `${backRoute?.[0] !== '/' ? '/' : ''}${backRoute}`
                          : backRoute,
                      );
                    else navigate(-1);
                  }}
                  type="button"
                  className="hidden p-1 mt-1 bg-transparent  flex-row outline-none rounded-full absolute top-0 left-8 hover:bg-neutral-40/[0.1]   "
                >
                  <img className="" src={leftArrow} alt="back" />
                  <span className="text-blue-00 text-base ml-2 ">
                    {t('buttons.back')}
                  </span>
                </button>
              )}
            </div>
            <div className="mt-0  flex-row flex justify-between md:mt-3 ">
              <div className=" relative md:mt-3 mt-0">
                <div className="flex items-center  md:mb-3">
                  <h2
                    className={`${
                      hasQueries && 'hidden lg:flex'
                    } font-bold text-2xl  text-neutral-12 text-left pt-0 inline`}
                  >
                    {title}
                  </h2>
                  {!!badgeInfo && (
                    <div
                      className={`${hasQueries && 'hidden lg:flex'} ${
                        outerBadgeCss ? outerBadgeCss : 'my-3'
                      } float-left ml-2`}
                    >
                      <BadgeCard {...badgeInfo} />
                    </div>
                  )}
                </div>
                {currentTabRoutes.length > 0 && (
                  <div className="sm:flex sm:flex-row relative whitespace-nowrap inline-block text-ellipsis   sm:mb-3 my-3 hover:bg-whitePressing ">
                    {currentTabRoutes.map((item: HeaderItemsModel) => (
                      <NavLink
                        key={item.path}
                        className={({ isActive }) =>
                          ` ${
                            isActive &&
                            '!bg-neutral-40 rounded-borderRadius10 !text-white/[0.87] '
                          }
                               rounded-borderRadius10 outline-none cursor-pointer  duration-300  border-none text-neutral-40
                              y-[0.375rem]  px-3 `
                        }
                        to={item.path}
                      >
                        {t(`${item.code}`)}
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>

              {!hasQueryRoute && !!dropDownMenuContent && (
                <div className="block sm:flex lg:hidden  ">
                  <Menu
                    open={isMenuOpen}
                    handler={setIsMenuOpen}
                    placement="bottom-end"
                  >
                    <MenuHandler>
                      <img
                        className="w-[19.5px] h-[19.5px] "
                        src={ThreeDotsIcon}
                        alt="close"
                      />
                    </MenuHandler>
                    <MenuList className="p-1">
                      <MenuItem
                        key={1}
                        onClick={closeMenu}
                        className={`flex items-center gap-2 rounded `}
                      >
                        {dropDownMenuContent}
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </div>
              )}
            </div>
            {topContent && (
              <div className="sticky left-0 z-20  top-0  clip-inset    py-4 ">
                <div className={'absolute h-[400px] w-full top-0  z-[-1] '} />
                {topContent}
              </div>
            )}
            {middleContent}
          </div>
        </div>
      </div>
      {rightPanel}
    </div>
  );

  return (
    <React.Fragment>
      {content}

      <Dialog
        open={!!(element && window.innerWidth < LARGE_BREAK_POINT)}
        handler={() => null}
        size={'xxl'}
        className="lg:!hidden overflow-hidden "
      >
        <DialogBody className="p-0">{rightPanel}</DialogBody>
      </Dialog>
    </React.Fragment>
  );
};

ModalLayoutComponent.defaultProps = {
  handle: () => ({}),
  disabled: false,
  showCloseButton: false,
  closeModal: () => ({}),
  middleContent: null,
  topContent: null,
  title: null,
  description: null,
  subDescription: null,
  element: null,
  placeHolder: null,
  dropDownMenuContent: null,
  badgeInfo: null,
  middleContentClass: null,
  loaderText: '',
  isCreating: false,
};
const ModalLayout = React.memo(ModalLayoutComponent);
export { ModalLayout };
